export default __webpack_public_path__ + "static/media/empty_km_table_with_distances.704e0df5.png";